import { useQuery } from '@tanstack/react-query';
import { getAuthenticated } from './api';
import { TopographyResponse } from '../models/topography.models';

export const useGetTopographyData = (
  latitude: number | undefined,
  longitude: number | undefined
) => {
  const url = `land/topography?north=${(latitude || 0) + 0.002}&south=${(latitude || 0) - 0.002}&east=${(longitude || 0) + 0.002}&west=${(longitude || 0) - 0.002}`;
  const { isPending, error, data } = useQuery<TopographyResponse>({
    enabled: !!(latitude && longitude),
    queryKey: ['topography', latitude, longitude],
    queryFn: async () => {
      return getAuthenticated<TopographyResponse>(url);
    },
  });
  return {
    loading: isPending,
    error,
    data: data?.body || undefined,
  };
};
